module.exports = __webpack_public_path__ + "static/1-e8814d7d453f1b0d1dfdc68875d702a7.jpg";